
import { gql } from '@apollo/client';

export const SUBMIT_DATA = gql`mutation MyMutation($kidsInfo: [ScrapperKidInfoRef] = [{age: 3}, {age: 10}]) {
  addScrapperInfo(input: {fromDate: "20-10-2021", toDate: "30-10-2021", numberOfAdults: 2, originAriport: "ZRH", destinationAirport: "COK", flightFareClass: Economy, flightInfos: NonStop, kidsInfo: $kidsInfo, sourceSystem: "Expedia"}) {
    numUids
  }
}`;
export const SUBMIT_REQUEST = gql`mutation MyMutation
(
$key:String
$name: String!,
$phone: String!,
$email: String!,
$from: String!,
$destination: String!,
$startDate: String!,
$endDate: String!,
$adultsCount: Int!,
$customFromItinerary:ItineraryRef,
$budget: String!,
$vacationType: [String!]
$submitTime: DateTime,
$roomRequirement: [String],
$resortRquirements: [String],
$previouslyStayedResortInfo: String,
$kidsCount: Int,
$interests: [String],
$bookingItems:[String],
$importantInfo: String,
$comment: String,
$roomInfo:[RoomInfoRef]
$tripDateFelxibility: Int,
$summary: String,
$cities: String,
$attractions: String,
$tours: String,
$stayRequirements:[String],
$questionType: TravelQuestionType
$amenities: [String]) {
  addTravelAnswer(input: {name: $name, 
    key:$key
    phone: $phone, 
    email: $email, 
    from: $from, 
    destination: $destination, 
    startDate: $startDate, 
    questionType: $questionType,
    endDate: $endDate, 
    customFromItinerary:$customFromItinerary,
    adultsCount: $adultsCount, 
    budget: $budget, 
    vacationType: $vacationType, 
    submitTime: $submitTime, 
    roomRequirement: $roomRequirement, 
    resortRquirements: $resortRquirements, 
    previouslyStayedResortInfo: $previouslyStayedResortInfo, 
    kidsCount: $kidsCount, 
    interests: $interests, 
    bookingItems: $bookingItems,
    importantInfo: $importantInfo, 
    comment: $comment, 
    cities:$cities,
    roomInfo: $roomInfo,
    tripDateFelxibility:$tripDateFelxibility,
    summary:$summary,
    attractions:$attractions,
    tours:$tours,
    stayRequirements:$stayRequirements,
    amenities: $amenities}) {
    numUids
  }
}`;



export const USER_PROFILE = gql`mutation MyMutation
(
$firstName: String,
$lastName: String,
$phone: String,
$email: String!,
$wishList: [ItineraryRef]
$isFirstLogin:Boolean!

) {
  addUserProfile(input: {
    firstName: $firstName,
    lastName: $lastName, 
    phone: $phone, 
    email: $email, 
    wishList: $wishList,
    isFirstLogin:$isFirstLogin

  }) {
    numUids
  }
}`;

export const UPADATE_USER_PROFILE = gql`mutation MyMutation
(
  $id: [ID!],
$firstName: String,
$lastName: String,
$phone: String,
$email: String!,
$wishList: [ItineraryRef],

){
  updateUserProfile(input: {filter: {id: $id},
    set:{
    firstName: $firstName,
    lastName: $lastName, 
    phone: $phone, 
    email: $email, 
    wishList: $wishList,
  }}) {
    numUids
  }
}`;

export const REMOVE_WISHLIST_USERPROFILE = gql`
mutation MyMutation(
  $id: [ID!],  
  $wishList: [ItineraryRef]
)
{
  updateUserProfile(input:{filter: {id: $id},
 remove:{
  wishList: $wishList
  }
})
  {
    numUids
  }
}`;

export const SEND_EMAIL = gql`mutation MyMutation
(
  $to: String!
  $subject: String!
  $body: String!
  $submitTime: DateTime
  $ccEmails: [String]
){
  addSendEmail(
    input:{
      to: $to
      subject: $subject
      body: $body
      ccEmails:$ccEmails
      submitTime: $submitTime
  }) {
    numUids
  }
}`;

export const SEND_EMAIL_ITINERARY = gql`mutation MyMutation
(
  $fromEmail: String
  $fromName: String
  $ccEmails: [String]
  $to: String!
  $subject: String!
  $body: String! 
  $submitTime: DateTime
){
  addSendEmail(
    input:{
      fromEmail:$fromEmail
      fromName:$fromName
      ccEmails:$ccEmails
      to: $to
      subject: $subject
      body: $body
      submitTime: $submitTime
  }) {
    numUids
  }
}`;


export const ADD_SHARE_NAME = gql`mutation MyMutation
(
  $name: String!
  $itinerary: ItineraryRef!
){
  addShareItinerary(input:{
    name:$name,
    itinerary:$itinerary
  }){
    numUids
    shareItinerary{
      id
    }
  }
}`;

export const UPDATE_DYNAMIC_ACCOMMODATION = gql`
  mutation MyMutation(
    $id: ID!, 
  $bookingStatus: BookingStatus
  $isVisible:Boolean!
  ) 
    {
    updateItineraryAccommodation(
      input: { filter: { id: [$id]}, 
      set: { 
       bookingStatus: $bookingStatus ,
       isVisible:$isVisible
      } 
      }
    ) {
      numUids
    }
  }
`;
export const UPDATE_DYNAMIC_TRAIN = gql`
  mutation MyMutation(
    $id: ID!, 
  $bookingStatus: BookingStatus
  $isVisible:Boolean!

  ) 
    {
    updateItineraryTrain(
      input: { filter: { id: [$id]}, 
      set: { 
       bookingStatus: $bookingStatus,
        isVisible:$isVisible
      } 
      }
    ) {
      numUids
    }
  }
`;
export const UPDATE_DYNAMIC_FERRY = gql`
  mutation MyMutation(
    $id: ID!, 
  $bookingStatus: BookingStatus,
  $isVisible:Boolean!

  ) 
    {
    updateItineraryFerry(
      input: { filter: { id: [$id]}, 
      set: { 
       bookingStatus: $bookingStatus ,
        isVisible:$isVisible
      } 
      }
    ) {
      numUids
    }
  }
`;
export const UPDATE_DYNAMIC_FLIGHT = gql`
  mutation MyMutation(
    $id: ID!, 
  $bookingStatus: BookingStatus,
  $isVisible:Boolean!

  ) 
    {
    updateItineraryFlight(
      input: { filter: { id: [$id]}, 
      set: { 
       bookingStatus: $bookingStatus ,
        isVisible:$isVisible
      } 
      }
    ) {
      numUids
    }
  }
`;
export const UPDATE_DYNAMIC_CARRENTAL = gql`
  mutation MyMutation(
    $id: ID!, 
  $bookingStatus: BookingStatus,
  $isVisible:Boolean!

  ) 
    {
    updateItineraryCarRental(
      input: { filter: { id: [$id]}, 
      set: { 
       bookingStatus: $bookingStatus,
        isVisible:$isVisible
      } 
      }
    ) {
      numUids
    }
  }
`;
export const UPDATE_DYNAMIC_RESTAURANT = gql`
  mutation MyMutation(
    $id: ID!, 
  $bookingStatus: BookingStatus,
  $isVisible:Boolean!

  ) 
    {
    updateItineraryRestaurant(
      input: { filter: { id: [$id]}, 
      set: { 
       bookingStatus: $bookingStatus,
        isVisible:$isVisible 
      } 
      }
    ) {
      numUids
    }
  }
`;
export const UPDATE_DYNAMIC_ACTIVITY = gql`
  mutation MyMutation(
    $id: ID!, 
  $bookingStatus: BookingStatus,
  $isVisible:Boolean!

  ) 
    {
    updateItineraryActivity(
      input: { filter: { id: [$id]}, 
      set: { 
       bookingStatus: $bookingStatus,
        isVisible:$isVisible 
      } 
      }
    ) {
      numUids
    }
  }
`;


export const UPDATE_DYNAMIC_CRUISE = gql`
mutation MyMutation(
$id: [ID!],
$bookingStatus:BookingStatus,
  $isVisible:Boolean!

  ) {
  updateItineraryCruise (
    input: {filter: {id: $id},
  
set:{
  bookingStatus:$bookingStatus,
   isVisible:$isVisible
    }}
  ) {
    numUids
  }
}`;

export const UPDATE_DYNAMIC_TRANSFER = gql`
mutation MyMutation(
  $bookingStatus:BookingStatus,
  $isVisible:Boolean!

 
  ) {
  updateItineraryTransfer (
    input: {filter: {id: $id},
  
set:{
  bookingStatus:$bookingStatus,
   isVisible:$isVisible
    }}
  ) {
    numUids
  }
}`;

export const UPDATE_BUILDER_DATA = gql`mutation MyMutation(
    $id: [ID!],
    $type:ItineraryType! 
  )  {
      updateItinerary(input:{filter: {id: $id}, 
      set: {
        type:  $type
      } } ) 
      {
        numUids
        }
    }`;

export const UPDATE_BOOKING_STATUS_INS = gql`
mutation MyMutation($id: [ID!]!, $bookingStatus: BookingStatus!) {
    updateItineraryInsurance(input: {filter: {id: $id}, set: {bookingStatus: $bookingStatus}}) {
        numUids
    }
}`;
export const UPDATE_BOOKING_STATUS_TRAIN = gql`
mutation MyMutation($id: [ID!]!, $bookingStatus: BookingStatus!) {
    updateItineraryTrain(input: {filter: {id: $id}, set: {bookingStatus: $bookingStatus}}) {
        numUids
    }
}`;
export const UPDATE_BOOKING_STATUS_FLIGHT = gql`
mutation MyMutation($id: [ID!]!, $bookingStatus: BookingStatus!) {
    updateItineraryFlight(input: {filter: {id: $id}, set: {bookingStatus: $bookingStatus}}) {
        numUids
    }
}`;
export const UPDATE_BOOKING_STATUS_ACCO = gql`
mutation MyMutation($id: [ID!]!, $bookingStatus: BookingStatus!) {
    updateItineraryAccommodation(input: {filter: {id: $id}, set: {bookingStatus: $bookingStatus}}) {
        numUids
    }
}`;
export const UPDATE_BOOKING_STATUS_CARRENTAL = gql`
mutation MyMutation($id: [ID!]!, $bookingStatus: BookingStatus!) {
    updateItineraryCarRental(input: {filter: {id: $id}, set: {bookingStatus: $bookingStatus}}) {
        numUids
    }
}`;